'use strict';

const globalConfig = require('../config/config');
const buttonConstants = require('../utils/button.constants');
const trackingHandler = require('../utils/tracking.handler');
const trackingUtils = require('od-modules/utils/tracking.utils');
const {trackOncePerPolicy} = require('od-modules/track_events/track.frontevents.additional.products');

const isDP = () => Odigeo.SessionScope.flowProduct === 'dp';
const dp = isDP() ? '.dp' : '';
const infoMessageOpened = 'opened';

const onInsuranceConditionsPDFLinkClick = () => trackingHandler.launch('termsAndConditionsOpen');
const onTermsConditionsPDFLinkClick = () => trackingHandler.launch('openCoverage');

module.exports = {
    bindPayWithGuaranteeButtons() {
        this.bindSingleButton(this.selectors.payWithGuaranteeButton, Odigeo.Events.tap, this.onContinueWithPayWithGuarantee.bind(this));
        this.bindSingleButton(this.selectors.payWithGuaranteeNormalButton, Odigeo.Events.tap, this.onContinueWithoutPayWithGuarantee.bind(this));
        this.bindSingleButton(this.selectors.payWithGuaranteeInfoMessage, Odigeo.Events.tap, this.onInfoMessageClick.bind(this));
        this.bindSingleButton(this.selectors.payWithGuaranteeInfoMessageClose, Odigeo.Events.tap, this.onInfoMessageClose.bind(this));
        this.bindSingleButton(this.selectors.payWithGuaranteeContainer, Odigeo.Events.tap, this.onPayWithGuaranteeContainerClick.bind(this));

        this.bindPayWithGuaranteeLinkTracking();

        trackOncePerPolicy(this.findElement(this.selectors.payWithGuaranteeButton));
    },

    bindPayWithGuaranteeLinkTracking() {
        this.bindSingleButton(this.selectors.payWithGuaranteeContainerPDFLink, Odigeo.Events.tap, onInsuranceConditionsPDFLinkClick);
        this.bindSingleButton(this.selectors.payWithGuaranteeTermsAndConditions, Odigeo.Events.tap, onTermsConditionsPDFLinkClick);
        this.bindSingleButton(this.selectors.paymentTermsAndConditions, Odigeo.Events.tap, onTermsConditionsPDFLinkClick);
    },

    initPayWithGuarantee(data) {
        this.findElement(this.selectors.payWithGuaranteeContainerPDFLink)
            .attr({'href': data.cancellationGuaranteeData.conditionsUrlExtended});
        const key = this.getPwgConditionsLinkMovedKey();
        const cancellationGuarantee = this.model.getCancellationGuarantee();
        const link = $(`<div>${key}</div>`);
        link.find('.pwg_conditions_pdf_link_moved').attr('href', cancellationGuarantee.conditionsUrlExtended);
        this.model.setPayWithGuaranteeTrackingConditionsData( {link: link.html()} );
    },

    getPwgConditionsLinkMovedKey() {
        const {c4arAsAVoucherDesktop = false} = this.model.getABs();
        const gdprWithoutCheckboxC4ARVoucherDesktopKey = this.keys[`paymentLegalTextNewPWG${dp}.FAN_PLUS4819.2`];
        return c4arAsAVoucherDesktop ? gdprWithoutCheckboxC4ARVoucherDesktopKey : this.removeCheckboxPaymentKey();
    },
    removeCheckboxPaymentKey() {
        const policy = this.model.getProductIdForPayWithGuarantee();
        const paymentLegalTextNewPWGKey = this.keys[`paymentLegalTextNewPWG${dp}:${policy}`];
        return paymentLegalTextNewPWGKey;
    },

    onContinueWithPayWithGuarantee(event) {
        event.preventDefault();
        event.stopPropagation();

        this.onInfoMessageClose(event);
        trackingUtils.startMetric('LOAD_CONFIRM_DESKTOP');

        const productId = this.model.getProductIdForPayWithGuarantee();

        this.getOnPaymentButton(buttonConstants.PAY_WITH_GUARANTEE, productId, this.onAddingPayWithGuaranteeProduct(productId))(event);
    },

    onAddingPayWithGuaranteeProduct(productId) {
        return () => {
            const model = this.model;

            return new Promise((resolve, reject) => {
                globalConfig.onContinueWithPayWithGuarantee(model, productId,
                    this.onContinueWithPayWithGuaranteeWithSuccess(resolve),
                    this.sendErrorPurchaseTracking(productId, reject)
                );
            });
        };
    },

    onContinueWithoutPayWithGuarantee(event) {
        this.onInfoMessageClose(event);
        this.getOnPaymentButton(buttonConstants.PAY_WITH_GUARANTEE_NORMAL)(event);
    },

    onContinueWithPayWithGuaranteeWithSuccess(resolve) {
        return () => resolve();
    },

    sendErrorPurchaseTracking(productId, reject) {
        return () => reject();
    },

    onInfoMessageClick(event) {
        event.stopPropagation();
        event.preventDefault();

        this.calculateInfoMessagePosition();
        trackingHandler.launchInfoMessageTracking(this.isInfoMessageOpened());
        this.getInfoMessageBox().toggleClass(infoMessageOpened);
    },

    getScrollTop(element) {
        return element.offset().top - $(window).scrollTop();
    },

    calculateInfoMessagePosition() {
        this.getInfoMessageBox()
            .removeClass('odf-message-box-contextual-mobile-top-center odf-message-box-contextual-mobile-bottom-center')
            .addClass(`odf-message-box-contextual-mobile-${this.getInfoMessageBoxPosition()}-center`);
    },

    getInfoMessageBoxPosition() {
        return this.shouldInfoMessageBeAtTop() ? 'top' : 'bottom';
    },

    shouldInfoMessageBeAtTop() {
        return this.getInfoMessagePositionAtViewPort() < this.getInfoMessageBox().outerHeight();
    },

    getInfoMessagePositionAtViewPort() {
        return this.getViewPortHeight() - this.getScrollTop(this.getInfoMessage());
    },

    getViewPortHeight() {
        return $(window).height();
    },

    getInfoMessageBox() {
        return this.findElement(this.selectors.payWithGuaranteeInfoMessageBox);
    },

    getInfoMessage() {
        return this.findElement(this.selectors.payWithGuaranteeInfoMessage);
    },

    onInfoMessageClose() {
        if (this.isInfoMessageOpened()) {
            this.getInfoMessageBox().removeClass(infoMessageOpened);
            trackingHandler.launch('whatIsClose');
        }
    },

    isInfoMessageOpened() {
        return this.getInfoMessageBox().hasClass(infoMessageOpened);
    },

    onPayWithGuaranteeContainerClick() {
        this.onInfoMessageClose();
    },

    getPriceLength(pricetype) {
        const prices = this.model.getPrices();
        return Odigeo.Utils.formatCurrency(prices[pricetype]).length;
    },

    getPricesLengthClass() {
        let priceSizeClass = 'od-pay-guarantee-price-size-medium';
        const getPriceLength = Math.max(this.getPriceLength('totalWithoutGuarantee'), this.getPriceLength('totalWithGuarantee'));
        if (getPriceLength >= 15) {
            priceSizeClass = 'od-pay-guarantee-price-size-highxl';
        } else if (getPriceLength >= 13 && getPriceLength <15) {
            priceSizeClass = 'od-pay-guarantee-price-size-high';
        } else if (getPriceLength <= 9) {
            priceSizeClass = 'od-pay-guarantee-price-size-low';
        }
        return priceSizeClass;
    },

};
